import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store/index';
import getLMSMaterialThunk from 'redux-store/thunks/lms/getLMSMaterialThunk';

import type { LMSMaterialState } from './types';

const initialState = {
  isFetched: false,
  material: {},
} as LMSMaterialState;
const LMSSlice = createSlice({
  name: 'lms',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getLMSMaterialThunk.fulfilled, (state, action) => {
      state.isFetched = true;
      state.material = action.payload;
    });

    builder.addCase(
      HYDRATE,
      (state, action: HydrateAction<LMSMaterialState>) => {
        return action.payload.lms;
      },
    );
  },
});

export default LMSSlice.reducer;
